/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ComputedTax } from './';
import {
    ComputedTaxFromJSON,
    ComputedTaxFromJSONTyped,
    ComputedTaxToJSON,
} from './';
import type { ConversionRate } from './';
import {
    ConversionRateFromJSON,
    ConversionRateFromJSONTyped,
    ConversionRateToJSON,
} from './';
import type { FreelancerFeeResource } from './';
import {
    FreelancerFeeResourceFromJSON,
    FreelancerFeeResourceFromJSONTyped,
    FreelancerFeeResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface QuoteScopeComputedValuesResource
 */
export interface QuoteScopeComputedValuesResource {
    /**
     * 
     * @type {number}
     * @memberof QuoteScopeComputedValuesResource
     */
    totalPriceExcludingTaxes?: number;
    /**
     * 
     * @type {ComputedTax}
     * @memberof QuoteScopeComputedValuesResource
     */
    vatTax?: ComputedTax;
    /**
     * 
     * @type {Array<ComputedTax>}
     * @memberof QuoteScopeComputedValuesResource
     */
    otherTaxes?: Array<ComputedTax>;
    /**
     * 
     * @type {Array<FreelancerFeeResource>}
     * @memberof QuoteScopeComputedValuesResource
     */
    freelancerFeesResource?: Array<FreelancerFeeResource>;
    /**
     * 
     * @type {number}
     * @memberof QuoteScopeComputedValuesResource
     */
    freelancerServiceFees?: number;
    /**
     * 
     * @type {number}
     * @memberof QuoteScopeComputedValuesResource
     */
    freelancerServiceFeesIncludingTaxes?: number;
    /**
     * 
     * @type {number}
     * @memberof QuoteScopeComputedValuesResource
     */
    freelancerServiceFeesTaxAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof QuoteScopeComputedValuesResource
     */
    totalPriceIncludingTaxes?: number;
    /**
     * totalPriceIncludingTaxes - freelancerServiceFees
     * @type {number}
     * @memberof QuoteScopeComputedValuesResource
     */
    freelancerEarnings?: number;
    /**
     * freelancerEarnings * conversionRate
     * @type {number}
     * @memberof QuoteScopeComputedValuesResource
     */
    freelancerEarningsWithConversion?: number;
    /**
     * 
     * @type {ConversionRate}
     * @memberof QuoteScopeComputedValuesResource
     */
    conversionRate?: ConversionRate;
    /**
     * 
     * @type {number}
     * @memberof QuoteScopeComputedValuesResource
     * @deprecated
     */
    freelancerServiceFeesPercent?: number;
    /**
     * 
     * @type {string}
     * @memberof QuoteScopeComputedValuesResource
     * @deprecated
     */
    freelancerFeeType?: QuoteScopeComputedValuesResourceFreelancerFeeTypeEnum;
}


/**
 * @export
 */
export const QuoteScopeComputedValuesResourceFreelancerFeeTypeEnum = {
    CountryFixedFeeRate: 'COUNTRY_FIXED_FEE_RATE',
    DefaultFeeRate: 'DEFAULT_FEE_RATE',
    ForcedFeeRate: 'FORCED_FEE_RATE',
    ReducedFeeRate: 'REDUCED_FEE_RATE',
    ZeroFeeBenefit: 'ZERO_FEE_BENEFIT',
    CustomClientFeeRate: 'CUSTOM_CLIENT_FEE_RATE',
    RepatriationFeeRate: 'REPATRIATION_FEE_RATE',
    MicroConsultingFeeRate: 'MICRO_CONSULTING_FEE_RATE'
} as const;
export type QuoteScopeComputedValuesResourceFreelancerFeeTypeEnum = typeof QuoteScopeComputedValuesResourceFreelancerFeeTypeEnum[keyof typeof QuoteScopeComputedValuesResourceFreelancerFeeTypeEnum];


/**
 * Check if a given object implements the QuoteScopeComputedValuesResource interface.
 */
export function instanceOfQuoteScopeComputedValuesResource(value: object): value is QuoteScopeComputedValuesResource {
    return true;
}

export function QuoteScopeComputedValuesResourceFromJSON(json: any): QuoteScopeComputedValuesResource {
    return QuoteScopeComputedValuesResourceFromJSONTyped(json, false);
}

export function QuoteScopeComputedValuesResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuoteScopeComputedValuesResource {
    if (json == null) {
        return json;
    }
    return {
        
        'totalPriceExcludingTaxes': json['totalPriceExcludingTaxes'] == null ? undefined : json['totalPriceExcludingTaxes'],
        'vatTax': json['vatTax'] == null ? undefined : ComputedTaxFromJSON(json['vatTax']),
        'otherTaxes': json['otherTaxes'] == null ? undefined : ((json['otherTaxes'] as Array<any>).map(ComputedTaxFromJSON)),
        'freelancerFeesResource': json['freelancerFeesResource'] == null ? undefined : ((json['freelancerFeesResource'] as Array<any>).map(FreelancerFeeResourceFromJSON)),
        'freelancerServiceFees': json['freelancerServiceFees'] == null ? undefined : json['freelancerServiceFees'],
        'freelancerServiceFeesIncludingTaxes': json['freelancerServiceFeesIncludingTaxes'] == null ? undefined : json['freelancerServiceFeesIncludingTaxes'],
        'freelancerServiceFeesTaxAmount': json['freelancerServiceFeesTaxAmount'] == null ? undefined : json['freelancerServiceFeesTaxAmount'],
        'totalPriceIncludingTaxes': json['totalPriceIncludingTaxes'] == null ? undefined : json['totalPriceIncludingTaxes'],
        'freelancerEarnings': json['freelancerEarnings'] == null ? undefined : json['freelancerEarnings'],
        'freelancerEarningsWithConversion': json['freelancerEarningsWithConversion'] == null ? undefined : json['freelancerEarningsWithConversion'],
        'conversionRate': json['conversionRate'] == null ? undefined : ConversionRateFromJSON(json['conversionRate']),
        'freelancerServiceFeesPercent': json['freelancerServiceFeesPercent'] == null ? undefined : json['freelancerServiceFeesPercent'],
        'freelancerFeeType': json['freelancerFeeType'] == null ? undefined : json['freelancerFeeType'],
    };
}

export function QuoteScopeComputedValuesResourceToJSON(value?: QuoteScopeComputedValuesResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'totalPriceExcludingTaxes': value['totalPriceExcludingTaxes'],
        'vatTax': ComputedTaxToJSON(value['vatTax']),
        'otherTaxes': value['otherTaxes'] == null ? undefined : ((value['otherTaxes'] as Array<any>).map((v) => ComputedTaxToJSON(v))),
        'freelancerFeesResource': value['freelancerFeesResource'] == null ? undefined : ((value['freelancerFeesResource'] as Array<any>).map((v) => FreelancerFeeResourceToJSON(v))),
        'freelancerServiceFees': value['freelancerServiceFees'],
        'freelancerServiceFeesIncludingTaxes': value['freelancerServiceFeesIncludingTaxes'],
        'freelancerServiceFeesTaxAmount': value['freelancerServiceFeesTaxAmount'],
        'totalPriceIncludingTaxes': value['totalPriceIncludingTaxes'],
        'freelancerEarnings': value['freelancerEarnings'],
        'freelancerEarningsWithConversion': value['freelancerEarningsWithConversion'],
        'conversionRate': ConversionRateToJSON(value['conversionRate']),
        'freelancerServiceFeesPercent': value['freelancerServiceFeesPercent'],
        'freelancerFeeType': value['freelancerFeeType'],
    };
}

